import React, { useState } from 'react';
import { Mail, Lock, AlertTriangle, ArrowRight, CheckCircle } from 'lucide-react';
import LoginForm from './LoginForm';
import OtpVerification from './OtpVerification';
import ConfirmDeletion from './ConfirmDeletion';
import SuccessMessage from './SuccessMessage';
import './styles.css';

import { LoginUser, VerifyOtp, DeleteAccount } from '../../services';; // Adjust the import path as necessary

const DeleteAccountPage: React.FC = () => {
  const [currentStep, setCurrentStep] = useState<number>(1);
  const [email, setEmail] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [otp, setOtp] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  // API calls - replace with actual API calls to your backend
  const handleLogin = async (email: string, password: string) => {
    setIsLoading(true);
    setError(null);
    console.log('Login attempt with email:', email);
    try {
      const deviceType = 'web';
      const deviceName = window.navigator.userAgent;
      const deviceId = 'browser-device-id'; // Replace with real unique ID if available
  
      const response = await LoginUser(email, password, deviceType, deviceName, deviceId);
      console.log('Login response from delete account page:', response);
      if (response?.accessToken) {
        setEmail(email);
        setPassword(password);
        localStorage.setItem('accessToken', response.accessToken ?? '');
        localStorage.setItem('refreshToken', response.refreshToken ?? '');
        setCurrentStep(2);
      } else {
        setError('Invalid response. Please try again.');
      }
    } catch (error: any) {
      console.error('Login error:', error);
      setError(error?.message || 'Login failed. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };
  
  

  // const handleVerifyOtp = async (otp: string) => {
  //   setIsLoading(true);
  //   setError(null);
  
  //   try {
  //     const verificationToken = localStorage.getItem('verificationToken') || '';
  //     const type = 'delete_account'; // or whatever type is applicable
  
  //     const response = await VerifyOtp(verificationToken, otp, type);
  
  //     if (response.success) {
  //       setOtp(otp);
  //       setCurrentStep(3);
  //     } else {
  //       setError(response.message || 'Invalid OTP. Please try again.');
  //     }
  //   } catch (error: any) {
  //     console.error('OTP verification error:', error);
  //     setError(error?.message || 'OTP verification failed. Please try again.');
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };
  

  const handleDeleteAccount = async () => {
    setIsLoading(true);
    setError(null);
  
    try {
      const response = await DeleteAccount(email, password);
      console.log('Delete account response from delete account page:', response);
      if (response.success) {
        localStorage.clear() 
        setCurrentStep(3);
      } else {
        setError(response.message || 'Failed to delete account. Please try again.');
      }
    } catch (error: any) {
      console.error('Account deletion error:', error);
      setError(error?.message || 'Account deletion failed. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };
  

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return <LoginForm onSubmit={handleLogin} isLoading={isLoading} error={error} />;
      case 2:
      //   return <OtpVerification onSubmit={handleVerifyOtp} isLoading={isLoading} error={error} email={email} />;
      // case 3:
        return <ConfirmDeletion onConfirm={handleDeleteAccount} isLoading={isLoading} error={error} />;
      case 3:
        return <SuccessMessage />;
      default:
        return <LoginForm onSubmit={handleLogin} isLoading={isLoading} error={error} />;
    }
  };

  return (
    <div className="delete-account-container">
      <div className="delete-account-card">
        <div className="header">
          <h1>Delete Account</h1>
          <div className="steps-indicator">
            <div className={`step ${currentStep >= 1 ? 'active' : ''}`}>
              <div className="step-number">1</div>
              <span className="step-label">Login</span>
            </div>
            {/* <div className="step-connector"></div>
            <div className={`step ${currentStep >= 2 ? 'active' : ''}`}>
              <div className="step-number">2</div>
              <span className="step-label">Verify</span>
            </div> */}
            <div className="step-connector"></div>
            <div className={`step ${currentStep >= 2 ? 'active' : ''}`}>
              <div className="step-number">2</div>
              <span className="step-label">Confirm</span>
            </div>
          </div>
        </div>
        <div className="content-section">
          {renderStep()}
        </div>
      </div>
    </div>
  );
};

export default DeleteAccountPage;